<template>
  <v-card>
    <v-data-table :headers="headers"
                  :items="tokens"
                  :items-per-page="10"
                  :footer-props="{'items-per-page-options': [5, 10, 25, 50]}"
                  :loading="loading"
                  loading-text="Loading connections...">
      <template v-slot:item.provider="{item: token}">
        <a @click.prevent="showInfo(token)">
          {{ token.provider.toUpperCase() }}
        </a>
      </template>
      <template v-slot:item.created_at="{item: token}">
        {{ token.created_at | datetime('MMM D, YYYY @ h:mm a') }}
      </template>

      <template v-slot:item.expires_at="{item: token}">
        <template v-if="token.expires_at">
          {{ token.expires_at | datetime('MMM D, YYYY @ h:mm a') }}
        </template>
        <template v-else>
          Never
        </template>
      </template>

      <template v-slot:item.actions="{item: token}">
        <!--v-btn icon>
          <v-icon @click.prevent="showInfo(token)">
            fal fa-info-circle
          </v-icon>
        </v-btn-->
        <v-btn icon
               @click.prevent="deleteToken(token)">
          <v-icon>
            fas fa-trash
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogInfo"
              v-if="token"
              max-width="500"
              @click:outside="closeDialog">
      <v-card>
        <v-card-title>
          Connection Details
        </v-card-title>
        <v-card-text>
          <connection-details :token="token">
          </connection-details>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.prevent="closeDialog"
                 text
                 color="primary">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete"
              max-width="500"
              @click:outside="closeDialog">
      <v-form>
        <v-card>
          <v-card-title>
            Are you sure you want to delete this connection?
          </v-card-title>
          <v-card-text></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text
                   @click="closeDialog">
              Cancel
            </v-btn>
            <v-btn color="primary"
                   text
                   @click="deleteTokenConfirm">
              OK
            </v-btn>
            <v-spacer>
            </v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-card>
</template>
<script>
import {Form} from 'vform';
import oauthService from '../../../../../ml/services/oauthService';
import ConnectionDetails from "./ConnectionDetails";

export default {
  components: {ConnectionDetails},
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    tokens: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      dialogDelete: false,
      dialogInfo: false,
      form: new Form({
        send_alert: false,
      }),
      headers: [
        {text: 'Service', value: 'provider', filterable: true,},
        {text: 'Created', value: 'created_at', filterable: false,},
        {text: 'Expires', value: 'expires_at', filterable: false,},
        {text: 'Actions', value: 'actions', filterable: false, sortable: false,},
      ],
      token: null,
    }
  },
  methods: {
    closeDialog() {
      this.dialogInfo = false;
      this.dialogDelete = false
      this.token = null;
    },
    deleteTokenConfirm() {
      if (this.token) {
        oauthService.deleteToken(this.token.id, this.form.send_alert)
          .then(() => {
            this.$emit('updated');
          })
          .finally(() => {
            this.token = null;
            this.dialogDelete = false;
          })
      }
    },
    deleteToken(token) {
      this.token = token;
      this.dialogDelete = true;
    },
    showInfo(token) {
      this.token = token;
      this.dialogInfo = true;
      this.dialogDelete = false;
    },
  }
}
</script>
